var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSizeback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow//Size2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.5 36C28.165 36 36 28.165 36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36Z",
    stroke: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6",
    d: "M10.3915 17.8928L15.5075 12.8018C15.6918 12.6199 15.9407 12.5184 16.1997 12.5195C16.4587 12.5207 16.7066 12.6244 16.8893 12.808C17.0719 12.9916 17.1744 13.2401 17.1743 13.4991C17.1741 13.7581 17.0714 14.0064 16.8885 14.1898L13.4535 17.6078H25.5835C25.8431 17.6078 26.0922 17.711 26.2758 17.8946C26.4594 18.0782 26.5625 18.3272 26.5625 18.5868C26.5625 18.8465 26.4594 19.0955 26.2758 19.2791C26.0922 19.4627 25.8431 19.5658 25.5835 19.5658H13.4545L16.8895 22.9838C17.0724 23.1672 17.1751 23.4156 17.1753 23.6746C17.1754 23.9335 17.0729 24.182 16.8903 24.3656C16.7076 24.5492 16.4597 24.6529 16.2007 24.6541C15.9417 24.6553 15.6928 24.5538 15.5085 24.3718L10.3925 19.2808C10.3011 19.1898 10.2286 19.0817 10.1791 18.9627C10.1296 18.8436 10.104 18.716 10.1039 18.587C10.1038 18.4581 10.1292 18.3304 10.1785 18.2113C10.2279 18.0921 10.3003 17.9839 10.3915 17.8928Z",
    fill: "#313131"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeback);
export default __webpack_public_path__ + "static/media/sizeback.8bf61c625c49aefa25f56ed0cda6bf4d.svg";
export { ForwardRef as ReactComponent };